import { IconSearch, IconX } from "@tabler/icons-react";

function Searchbar({ value, clear, ...props }) {
  return (
    <div className="w-full">
      <div className="w-64">
        <div className="mt-2">
          <div className="flex rounded-md bg-white outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 dark:bg-white/5 dark:outline-1 dark:-outline-offset-1 dark:outline-white/10 dark:focus-within:outline-indigo-500">
            <input
              id="search"
              name="search"
              type="text"
              placeholder="Search..."
              value={value}
              {...props}
              className="block min-w-0 grow px-3 py-1.5 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6 dark:bg-transparent dark:text-white dark:placeholder:text-gray-500"
            />
            <div className="flex py-1.5 pr-1.5">
              <div className="inline-flex items-center rounded-sm px-1 font-sans text-xs text-gray-400 ">
                {value ? <IconX onClick={clear} /> : <IconSearch />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Searchbar;
